import { render, staticRenderFns } from "./add_pay_info_public_step2_dialog.vue?vue&type=template&id=c64e6a18"
import script from "./add_pay_info_public_step2_dialog.vue?vue&type=script&lang=js"
export * from "./add_pay_info_public_step2_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_pay_info_public_step2_dialog.vue?vue&type=style&index=0&id=c64e6a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports